// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d17080b5","43":"f7b7b775","127":"ce3ccd27","141":"b6acb350","283":"f9999031","447":"d3ea3cc9","453":"e919c1a9","731":"515b9540","751":"626c678b"}[chunkId] + ".chunk.js";
};